import { render, staticRenderFns } from "./GetLeaveBack.vue?vue&type=template&id=a81d1166&scoped=true"
import script from "./GetLeaveBack.vue?vue&type=script&lang=js"
export * from "./GetLeaveBack.vue?vue&type=script&lang=js"
import style0 from "./GetLeaveBack.vue?vue&type=style&index=0&id=a81d1166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81d1166",
  null
  
)

export default component.exports